import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

// Service
import { ApiService } from '../../../shared/service/api.service';
import { GlobalService } from '../../../shared/service/global.service';

@Component({
  selector: 'app-annual-report',
  templateUrl: './annual-report.component.html',
  styles: [
  ]
})
export class AnnualReportComponent implements OnInit {

  dataTitle;
  urlApi;
  btnLoad = true;
  dataAnnual = [];
  textLoad = 'Load More';

  constructor(private apiService: ApiService, 
              private globalService: GlobalService,
              private router: Router) {
  this.globalService.isLoading.next(true); 
  }

  ngOnInit(): void {
    // Content
    this.apiService.getDataApi('getMenuSection/annual-reports').subscribe(response => {
      if(response.success){
        this.dataTitle = response.data;
        // Meta
        this.globalService.updateMeta(
          response.data.title + ' | Prime Agri Resources',
          response.data.keyword,
          response.data.metadesc
        );
      }else{
        this.router.navigate(['/not-found']);
      }
    });

    // docs
    this.apiService.getDataApi('getAnnualReports').subscribe(response => {
      this.getAnnual(response.data);
      this.globalService.isLoading.next(false);
    });
  }

  getAnnual(dataAnnual){
    dataAnnual.data.forEach( (i,x) => {
      this.dataAnnual.push(i);
    });
    this.urlApi = dataAnnual.next_page_url;
    if(this.urlApi === null){
      this.btnLoad = false;
    }
  }

  getMore(){
    this.textLoad = 'Loading...';
    if(this.urlApi) {
      this.apiService.getNextPage(this.urlApi).subscribe(response => {
        this.getAnnual(response.data);      
        this.textLoad = 'Load More';
      });
    }
  }

}
